// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MediumSquareFilledSvg from "@ant-design/icons-svg/es/asn/MediumSquareFilled";
import AntdIcon from '../components/AntdIcon';

var MediumSquareFilled = function MediumSquareFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: MediumSquareFilledSvg
  }));
};

MediumSquareFilled.displayName = 'MediumSquareFilled';
export default React.forwardRef(MediumSquareFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/MediumSquareFilled.js
// module id = 1463
// module chunks = 0